var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTorch = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#E7E8EB"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7729_19929)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0411 9.25586C10.0411 8.69917 10.4987 8.27441 11.0276 8.27441H20.9724C21.5013 8.27441 21.9589 8.69917 21.9589 9.25586V12.2994C21.9589 12.8561 21.5013 13.2809 20.9724 13.2809H20.438L19.3338 16.1976V23.2677C19.3338 23.7851 18.9158 24.226 18.3827 24.226H13.6173C13.0842 24.226 12.6662 23.7851 12.6662 23.2677V16.2099L11.5512 13.2809H11.0276C10.4987 13.2809 10.0411 12.8561 10.0411 12.2994V9.25586ZM11.5411 9.77441V11.7809H12.0682H12.5852L12.5864 11.784H19.4008L19.402 11.7809H19.92H20.4589V9.77441H11.5411ZM18.8329 13.284H13.1574L14.1172 15.8052L14.1662 15.9341V16.072V22.726H17.8338V16.0604V15.9232L17.8823 15.7949L18.8329 13.284ZM15.315 20.164V17.2825H16.815V20.164H15.315Z",
  fill: "#676879"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7729_19929"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(6 6)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTorch);
export default ForwardRef;